import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

export const Desktop: React.FC<React.PropsWithChildren> = ({ children }) => {
  const deviceType = useDeviceType();

  return deviceType === 'desktop' ? (children as React.ReactElement) : null;
};

Desktop.displayName = 'ResponsiveDesktop';
